export function safeHttpUrl (value) {
  if (typeof value !== 'string') return null

  try {
    const url = new URL(value.trim())
    if (url.protocol === 'http:' || url.protocol === 'https:') return url.href
  } catch (error) {}

  return null
}
